import { Injectable } from '@angular/core';
import { BehaviorSubject, interval } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from '../../core';
import { DateTimeUtils } from '../../utils';
import { AbstractStorageService } from '../storage/abstract-storage.service';

@Injectable({
  providedIn: 'root',
})
export class ResendPinCountdownService extends BaseComponent {
  private readonly TIME_TO_WAIT_IN_SECOND = 61;
  private readonly TICK_TIME_IN_MS = 1000;

  private resendPinCountdownInSecond$$ = new BehaviorSubject<number>(0);
  public readonly resendPinCountdownInSecond$ =
    this.resendPinCountdownInSecond$$.asObservable();

  constructor(private storageService: AbstractStorageService) {
    super();

    this.setResendPinLogin(this.storageService.getResendPinLoginTimestamp());
  }

  public setResendPinCountdownNow(): void {
    this.setResendPinLogin(new Date());
  }

  private setResendPinLogin(timestamp: Date): void {
    if (!timestamp) {
      return;
    }

    this.storageService.saveResendPinTimestamp(timestamp);
    this.startCountdown(timestamp);
  }

  private startCountdown(startTime: Date): void {
    const expiredTimestamp = new Date(
      startTime.getTime() + this.TIME_TO_WAIT_IN_SECOND * 1000
    );

    this.calculateAndEmitCountdown(null, new Date(), expiredTimestamp);

    const intervalSubscription = interval(this.TICK_TIME_IN_MS)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(() =>
        this.calculateAndEmitCountdown(
          intervalSubscription,
          new Date(),
          expiredTimestamp
        )
      );
  }

  private calculateAndEmitCountdown(
    intervalSubscription: any,
    startTime: Date,
    endTime: Date
  ): void {
    if (startTime >= endTime) {
      if (intervalSubscription) {
        intervalSubscription.unsubscribe();
      }

      this.storageService.removeResendPinTimestamp();
      this.resendPinCountdownInSecond$$.next(0);
    } else {
      this.resendPinCountdownInSecond$$.next(
        DateTimeUtils.getDiffInSecond(endTime, startTime)
      );
    }
  }
}
